import { api } from "../../gateways/unilabApi";

export async function getPressuresList() {
  return await api.get(`pressures/list`);
}
export async function getPressuresListByMod(payload) {
  var mod = payload.mod;
  var isSaldobrasata = payload.isSaldobrasata;
  return await api.get(`pressures/listByMod?mod=${mod}&isSaldobrasata=${isSaldobrasata}`);
}

export async function getPressuresExportList() {
  return await api.get(`pressures/listExport`);
}

export async function postUpdateAddAllExport(payload) {
  return await api.post(`pressures/updateAddAllExport`, payload);
}
export async function getExportModel() {
  return await api.get(`pressures/exportModel`);
}
